export const searchAddress = {
  methods: {
    searchAddress() {
      return new Promise((resolve, reject) => {
        let script = document.createElement("script");
        script.onload = () => {
          resolve(true);
          return true;
        };
        script.async = true;
        script.src = "/js/bundle.min.js";
        document.head.appendChild(script);
      });
    },
  },
};
